import { Chip } from '../../../ui';
import { LABEL } from '../styles';

export interface ChoiceChipsProps<T extends string> {
  label: string;
  value: T;
  options: { value: T; label: string }[];
  onChange(value: T): void;
}

/**
 * A single-choice group of chips that wraps onto new lines at phone width (Segmented's pill
 * container gets bulky with four long options). Radio semantics, like Segmented.
 */
export function ChoiceChips<T extends string>({
  label,
  value,
  options,
  onChange,
}: ChoiceChipsProps<T>) {
  return (
    <div className="flex flex-col gap-1">
      <span aria-hidden="true" className={LABEL}>
        {label}
      </span>
      <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
        {options.map((o) => (
          <Chip
            key={o.value}
            role="radio"
            aria-checked={value === o.value}
            selected={value === o.value}
            onClick={() => onChange(o.value)}
          >
            {o.label}
          </Chip>
        ))}
      </div>
    </div>
  );
}
